import { useTalentImage } from "../../actions/authActions";
export default () => {
  const { data: talentImageList, isError, error } = useTalentImage();
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading talent: {error.message}</p>
      </div>
    );
  }
  const settings = {
    dots: false,
    infinite: true,
    // speed: 700,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 1280, // XL screens
        settings: {
          slidesToShow: 8,
        },
      },
      {
        breakpoint: 1024, // LG screens
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768, // MD screens
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 640, // SM screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // XS screens
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };
  return { talentImageList, settings };
};
